export let mondayUppercase = "WlRup";
export default {mondayUppercase};